import {TextField} from "@material-ui/core";
import {Button, Form} from "react-bootstrap";
import {useEffect, useState} from "react";
import Message from "../message";

function Linkedin_url_fast() {
    const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;

    const [emails_col_name, setEmails_col_name] = useState("");
    const [emails, setEmails] = useState("");
    const [status_emails, setStatus_emails] = useState("");
    const [status_serp_creds, setStatus_serp_creds] = useState("fetching...");

    useEffect(async () => {
        const creds_remaining = await fetch(
            apiServer + "api/helper/value_serp_account"
        );
        setStatus_serp_creds(await creds_remaining.json());
    }, []);

    const sumbit_emails = async () => {
        setStatus_emails("");

        if (emails.length <= 0) {
            setStatus_emails("Upload some files!");
        } else if (emails_col_name === "") {
            setStatus_emails("Fill column name!");
        } else {
            const emails_formData = new FormData();
            emails_formData.set("file", emails);

            const requestOptions = {
                method: "POST",
                body: emails_formData,
            };

            try {
                const emails_response = await fetch(
                    apiServer +
                    `api/linkedin_url_fast/upload_file?col_name=${emails_col_name}`,
                    requestOptions
                );
                const emails_status_id = await emails_response.json();
                const emails_status = emails_status_id.detail
                    ? emails_status_id.detail
                    : emails_status_id;
                setStatus_emails(emails_status);
            } catch (e) {
                console.log(e);
            }
        }
    };

    return (
        <div style={{marginTop: "2px"}}>
            <p>
                Credits remaining: <strong>{status_serp_creds}</strong>
            </p>
            <TextField
                style={{marginBottom: "15px", width: "100%"}}
                value={emails_col_name}
                onChange={(e) => setEmails_col_name(e.target.value)}
                id="outlined-basic"
                label="Column name"
                variant="filled"
            />
            <Form.Control
                type="file"
                onChange={(e) => setEmails(e.target.files[0])}
            />
            <Button
                variant="primary"
                style={{marginTop: "20px", width: "100%"}}
                onClick={() => sumbit_emails()}
            >
                Submit
            </Button>
            {Message(status_emails, setStatus_emails)}
        </div>
    );
}

export default Linkedin_url_fast;
